





















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ProjectModel } from "../models";
import { FileEntryModel } from "../models/fileEntry";
import FileFilter from "../components/FileFilter.vue";
import FileList from "../components/FileList.vue";
import UploadForm from "../components/UploadForm.vue";

const pStore = namespace("projectsupload");
const snackStore = namespace("snackbar");

@Component({
  components: { FileFilter, FileList, UploadForm },
})
export default class Project extends Vue {
  @pStore.Getter project!: (id: number) => ProjectModel;
  @pStore.Action fetchProject!: (id: number) => Promise<void>;
  @snackStore.Mutation defaultError!: () => void;
  @pStore.Getter fileEntries!: (id: number) => FileEntryModel[];
  @pStore.Action fetchFileEntriesForProject!: (id: number) => Promise<void>;

  filteredFiles: FileEntryModel[] = [];
  loading = true;

  get projectID(): number {
    return Number(this.$route.params.id);
  }

  get p(): ProjectModel {
    return this.project(this.projectID);
  }

  get files(): FileEntryModel[] {
    return this.fileEntries(this.projectID);
  }

  async mounted(): Promise<void> {
    try {
      await Promise.all([
        this.fetchProject(this.projectID),
        this.fetchFileEntriesForProject(this.projectID),
      ]);
    } catch (e) {
      this.defaultError();
    } finally {
      this.loading = false;
    }
  }

  reload(): void {
    this.fetchFileEntriesForProject(this.projectID);
  }
}
